import AntDIcon from 'antd/lib/icon'
import React from 'react'

const Icon = ({ size }) => {
  const SVG = () => (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 12H16'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M12 8L16 12L12 16'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle
        cx='6'
        cy='12'
        r='3'
        stroke='currentColor'
        strokeWidth='2'
        fill='none'
      />
      <circle
        cx='18'
        cy='12'
        r='3'
        stroke='currentColor'
        strokeWidth='2'
        fill='none'
      />
    </svg>
  )
  return <AntDIcon component={SVG} />
}
export default Icon
